export default __webpack_public_path__ + "static/media/empty.7e74d10d.png";